import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-351ffcdd"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-wrapper"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202411/c7691e0d20f84f8fb019b1c78365efd5.png"
}, null, -1));

const _hoisted_4 = [_hoisted_2, _hoisted_3];
const _hoisted_5 = {
  class: "course-left"
};
const _hoisted_6 = {
  class: "course-title"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "left-icon",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202411/41dc69922ea54cd5a426c977c80d7091.png"
}, null, -1));

const _hoisted_8 = {
  class: "center-text"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right-icon",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202411/813d8e159e69482492ed4b4674b288d6.png"
}, null, -1));

const _hoisted_10 = {
  key: 0,
  class: "swiper-box"
};
const _hoisted_11 = {
  class: "video-cover"
};
const _hoisted_12 = {
  class: "video-cover-img"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  key: 0,
  class: "video-time"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "play-icon"
}, null, -1));

const _hoisted_16 = {
  class: "video-title"
};
const _hoisted_17 = {
  class: "video-info"
};
const _hoisted_18 = {
  class: "teacher-icon"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "teacher-name"
};
const _hoisted_21 = {
  class: "teacher-org"
};
const _hoisted_22 = {
  class: "video-schedule"
};
const _hoisted_23 = {
  key: 1
};
const _hoisted_24 = {
  class: "no-data"
};
const _hoisted_25 = {
  class: "course-right"
};
const _hoisted_26 = {
  class: "user-box"
};
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import SwiperCore, { Navigation, A11y, Autoplay, Pagination, EffectCoverflow } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import VideoDialog from '@/pages/components/FilePreview/VideoDialog.vue';
import UserCard from './UserCard/index.vue';
import { dateTransfer } from '@/plugins/utils';
import { Empty } from 'zhs-components';
export default {
  props: {
    userInfo: {
      type: Object,
      default: null
    },
    zhsRole: {
      type: Number || String,
      default: 0
    },
    menu: {
      type: Object,
      default: null
    }
  },
  emits: ['updateZhsRole'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    SwiperCore.use([Navigation, A11y, Autoplay, Pagination, EffectCoverflow]);
    const modules = [Navigation, A11y, Autoplay, Pagination, EffectCoverflow];
    const $http = inject('$http');
    const courseList = ref([]);
    const coverflowEffect = {
      rotate: 0,
      //slide做3d旋转时Y轴的旋转角度。默认50。
      stretch: 126,
      //每个slide之间的拉伸值，越大slide靠得越紧。
      depth: 100,
      //slide的位置深度。值越大z轴距离越远，看起来越小。
      modifier: 1,
      //depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
      slideShadows: true //开启slide阴影。默认 true。

    };

    const getCourseList = async () => {
      const res = await $http.getWonderfulClassList({
        page: 1,
        pageSize: 10
      });
      courseList.value = res.list;
    };

    getCourseList();

    const updateZhsRole = val => {
      emits('updateZhsRole', val);
    };

    const showVideoDialog = ref(false);
    const videoInfo = reactive({
      url: '',
      title: ''
    });

    const handleDetail = item => {
      videoInfo.url = item.fileUrl;
      videoInfo.title = item.courseName;
      showVideoDialog.value = true;
    };

    const handleMore = () => {
      let navItemInfo = JSON.parse(sessionStorage.getItem('authInfo'));
      let nav = navItemInfo.find(item => item.function_id == '18100');

      if (nav) {
        window.location.href = `/wonderfulClass.html?menuId=${nav.menu_id}&name=${nav.nav_name}`;
      }
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("section", _hoisted_1, [_createElementVNode("div", {
        class: "more-btn"
      }, [_createElementVNode("a", {
        onClick: handleMore
      }, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString(__props.menu && __props.menu.module_name || '精彩课堂'), 1), _hoisted_9]), courseList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_unref(Swiper), {
        watchSlidesProgress: true,
        slidesPerView: "2.9",
        centeredSlides: true,
        loop: true,
        navigation: true,
        pagination: {
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 300000
        },
        effect: "coverflow",
        "coverflow-effect": coverflowEffect,
        modules: modules
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList.value, (item, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            class: "swiper-slide",
            key: index,
            onClick: $event => handleDetail(item)
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
              src: item.cover || require('@/assets/images/video-cover.png'),
              alt: ""
            }, null, 8, _hoisted_13)]), item.liveDuration ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(dateTransfer)(item.liveDuration)), 1)) : _createCommentVNode("", true), _hoisted_15]), _createElementVNode("div", _hoisted_16, _toDisplayString(item.courseName), 1), _createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, [_createElementVNode("img", {
              src: item.avatar || require('@/assets/images/common/teacher_icon.png'),
              alt: ""
            }, null, 8, _hoisted_19)]), _createElementVNode("span", _hoisted_20, _toDisplayString(item.teacherName), 1), _createElementVNode("span", _hoisted_21, _toDisplayString(item.kkxy), 1)]), _createElementVNode("div", _hoisted_22, _toDisplayString(item.stime) + "-" + _toDisplayString(item.endTime), 1)]),
            _: 2
          }, 1032, ["onClick"]);
        }), 128))]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(_unref(Empty))])]))]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(UserCard, {
        userInfo: __props.userInfo,
        zhsRole: __props.zhsRole,
        onUpdateZhsRole: updateZhsRole
      }, null, 8, ["userInfo", "zhsRole"])])])]), _createVNode(VideoDialog, {
        show: showVideoDialog.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => showVideoDialog.value = $event),
        videoInfo: _unref(videoInfo)
      }, null, 8, ["show", "videoInfo"])], 64);
    };
  }

};